<template>
  <b-card>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="remarks"
            rules="required"
          >
            <b-form-group
              label="remarks"
              label-for="remarks"
            >
              <b-form-textarea
                id="remarks"
                v-model="assignedForm.remarks
                "
                trim
                placeholder="remarks"
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="responsible employee"
            rules="required"
          >
            <b-form-group
              label="responsible employee"
              label-for="responsible employee"
            >
              <b-form-select
                id="responsible_employee"
                v-model="assignedForm.responsible_employee"
                :options="optionsUsers"
                text-field="label"
                value="value"
                :state="getValidationState(validationContext)"
                trim
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="valid"
            rules="required"
          >
            <b-form-group
              label="valid"
              label-for="valid"
            >
              <b-form-checkbox
                id="valid"
                v-model="assignedForm.valid"
                name="valid"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col md="6">
          <validation-provider
            #default="validationContext"
            name="category"
            rules="required"
          >
            <b-form-group
              label="category"
              label-for="category"
            >
              <b-form-checkbox
                v-model="assignedForm.category"
                value="external"
              >external
              </b-form-checkbox>
              <b-form-checkbox
                v-model="assignedForm.category"
                value="internal"
              >internal
              </b-form-checkbox>
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
        </b-col>

        <!-- Server Errors -->
        <b-col
          v-if="Object.values(errors).length > 0"
          cols="12"
        >
          <p
            v-for="(error, key, index) in errors"
            :key="index"
            class="text-danger small"
          >
            {{ error.toString() }}
          </p>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="mt-50"
        >
          <b-button
            v-if="!loader && $route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addAdminInitial()"
          >
            Save Changes
          </b-button>
          <b-button
            v-if="!loader && !$route.params.id"
            variant="primary"
            class="mr-1"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addAdminInitial()"
          >
            Add
          </b-button>
          <b-button
            v-if="loader"
            variant="primary"
            disabled
            class="mr-1"
          >
            <b-spinner
              small
              type="grow"
            />
            Loading...
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import { ref } from '@vue/composition-api'
import formValidation from '@core/comp-functions/forms/form-validation'
import axios from 'axios'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
// import decryptData from '@/store/auth/decryptData'

export default {
  data() {
    return {
      required,
      loader: false,
      validationErrors: {},
      errors: {},
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    // eslint-disable-next-line camelcase

    const assignedForm = ref({
    })
    return {
      getValidationState,
      assignedForm,
    }
  },
  computed: {
    optionsUsers() {
      return this.$store.getters['generalData/engineersList/engineersList']
    },
  },
  async mounted() {
    if (!this.$store.getters['generalData/engineersList/engineersLoaded']) {
      await this.$store.dispatch('generalData/engineersList/fetchEngineersList')
    }
  },
  methods: {

    addAdminInitial() {
      this.loader = true
      // const formData = new FormData()

      // Object.entries(this.assignedForm).forEach(([key, value]) => {
      //   formData.append(key, value)
      // })
      const payload = {
        ...this.assignedForm,
      }

      axios
        .post(`complaints/${this.$route.params.id}/process/assigned`, payload)
        .then(res => {
          if (res.status === 200 || res.status === 201) {
            this.$router.push({ name: 'assigned-complaint' })
            this.$toasted.show('Assigned Successfully', {
              position: 'top-center',
              duration: 3000,
            })
          }
        })
        .catch(error => {
          if (error.response.status) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: `${error.response.data.message}`,
                icon: 'BellIcon',
                variant: 'error',
              },
            })
          }
        })
        .finally(() => {
          this.loader = false
        })
    },

  },
}
</script>
